import React from "react";

const HighlightRibbonThree = () => {
  return (
    <>
      <section className="container-fluid container--ribbon__highlight">
        <div className="section-width card-wrapper">
          <div className="card card--highlight">
            <p className="numeral">100%</p>
            <p className="card-text card-text-highlight">
              focus on student’s growth
            </p>
          </div>
          <div className="card card--highlight">
            <p className="numeral">3</p>
            <p className="card-text card-text-highlight">
              step: Explain, Practice, Excel
            </p>
          </div>
          <div className="card card--highlight">
            <p className="numeral">50+</p>
            <p className="card-text card-text-highlight">
              parents trust us
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default HighlightRibbonThree;
